module.exports = __webpack_public_path__ + "media/sh_reel.a3e81311.mp4";